// Copyright (c) 2018 Comsearch, Inc., All rights reserved

const create2dArrayOfResults = (columns, rows, { col, asc }) => {
  // rows is an array of objects, the results displayed in UI.
  // each in columns array should map to a primitive value in the rows[n] objects.
  // if you need to export a cell which is not a primitive value (nested tabluar data, tooltips etc)
  // (for an example see ./Sets/RadioDb/columns ==> modulations)
  // then you must scrub the data to export before running exportResults in <SearchAndSelect />
  // the scrubbed data must have a primitive representation, even if just an empty string
  // to successfully create a CSV of the results list.
  const csvData = []

  const cHeadings = columns.reduce((a, d) => {
    const h = d.columnHeader
    const s = d.columnKey === col ? ` (${asc ? 'Ascending' : 'Descending'})` : ``
    a.push(`${h}${s}`)
    return a
  }, [])
  csvData.push(cHeadings)

  rows.map(rowData => {
    const rd = columns.reduce((a, d) => {
      const {
        cellFormatter,
        columnKey,
      } = d

      // if the cell has a custom formatter, it should also have an exportValue method
      // which returns the value as we wish to see it in the CSV. This may be the same
      // as in the UI (dates from epoch to YYYY/MM/DD) or
      // it may be different (status cells as a string and not a colored icon.)
      const exportValue = (
        cellFormatter && cellFormatter.exportValue
          ? cellFormatter.exportValue({ columnKey, rowData })
          : rowData[columnKey]
      )

      a.push(exportValue)
      return a
    }, [])
    csvData.push(rd)
  })
  return csvData
}

export default create2dArrayOfResults
